import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_BILLING_MIGRATION_STRATEGIES: MigrationStrategies = {};
